var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40.4 1.01)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.275 -0.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.725,27.594c0-4.235,3.238-6.994,8.23-8.671A16.641,16.641,0,0,1,29.7,20.947l1.867-1.539a17.563,17.563,0,0,0-5.45-2.653c4.13-2,5.342-6.966,4-10.61A10.182,10.182,0,0,0,20.35-.448,10.2,10.2,0,0,0,10.57,6.145c-1.338,3.644-.114,8.606,4.016,10.61C8.221,18.623,4.006,22.3,4,27.594l-.05,5.834A1.24,1.24,0,0,0,5.313,34.49H23.025V32.367H6.675Zm6.15-19.1c0-3.517,2.96-6.805,7.475-6.805s7.463,3.288,7.463,6.805a7.569,7.569,0,0,1-7.463,7.436,7.579,7.579,0,0,1-7.475-7.436Z",
    transform: "translate(-4 0.26)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.368,25.245V21H23.245v4.245H19v2.123h4.245v4.245h2.123V27.368h4.245V25.245Z",
    transform: "translate(5.012 1.548)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateUserIcon);
export default __webpack_public_path__ + "static/media/create-user-icon.1522bd884ae3a7da376d9a6819d73345.svg";
export { ForwardRef as ReactComponent };